module.exports = __webpack_public_path__ + "img/logo.3794c017.png";